import React from 'react'
import { HelpSupportScreen } from '../../../components/settings/HelpSupportScreen'

export default function HelpSupportRoute() {
  return <HelpSupportScreen />
}
